export default __webpack_public_path__ + "static/favicon-5b45ab6bad9c619094230bbbbd35f7cb.ico";